import { createAnimations } from '@tamagui/animations-css'
import { createGBConfig } from '@greenbackapp/ui'

const animations = createAnimations({
  fast:   'ease in 120ms',
  medium: 'ease in 220ms',
  slow:   'ease in 360ms',
  spring: 'ease in 220ms',
})

export const tamaguiConfig = createGBConfig(animations)

export type Conf = typeof tamaguiConfig
declare module 'tamagui' {
  interface TamaguiCustomConfig extends Conf {}
}
